import { Component, OnInit, ViewChild } from '@angular/core';
import { Authenticate } from "../../models/authenticate";
import { Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { CurrencyPipe } from '@angular/common';


@Component({
  selector: 'app-results',
  templateUrl: './results.html',
  styleUrls: ['./results.css'],
    imports: [ CurrencyPipe],

})
export class Results implements OnInit {

  authenticate: any;
  showDivSourceMessage: boolean = false;
  showDivNoticeMessage: boolean = false;
  au: Authenticate;

  constructor(
    private _router: Router,
    private storage: LocalStorageService,
  ) { }

  ngOnInit() {
    this.au = this.storage.retrieve('authenticatedUser');
      this.showDivNoticeMessage = true;
    this.showDivSourceMessage = true;
    
   
    
  }
}
